import { memo, useEffect, useState } from 'react';

import { Form, Input, Select } from 'antd';

import equal from 'fast-deep-equal';

import messages from '../../../constants/messages';

function CreateTagForm({ formRef, farm_opts, onChange, setSubmittable }) {
  const [form] = Form.useForm();

  const [initialFormValues, setInitialFormValues] = useState({});

  if (formRef) formRef.current = form;

  const values = Form.useWatch([], form);

  useEffect(() => {
    const initial = form.getFieldsValue(true);
    setInitialFormValues(initial);
  }, []);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [values]);

  function handleChange() {
    const current = form.getFieldsValue();
    const isSame = equal(current, initialFormValues);

    onChange?.(!isSame);
  }

  return (
    <Form
      className="py-4"
      layout="vertical"
      variant="outlined"
      form={form}
      initialValues={{
        type: null,
        deveui: null,
        diagri_id: null,
        version: null,
        firmware_version: null,
        farm_id: farm_opts?.at(0)?.id
      }}
      requiredMark={true}
      onValuesChange={handleChange}>
      <Form.Item label="Type" name="type" rules={[{ required: true, message: messages.FIELD_REQUIRED('Type') }]}>
        <Input placeholder="Type" />
      </Form.Item>
      <Form.Item
        label="Tag DEVEUI"
        name="deveui"
        rules={[{ required: true, message: messages.FIELD_REQUIRED('Tag DEVEUI') }]}>
        <Input placeholder="DEVEUI" />
      </Form.Item>
      <Form.Item
        label="Kraal Tag ID"
        name="diagri_id"
        rules={[{ required: true, message: messages.FIELD_REQUIRED('Kraal Tag ID') }]}>
        <Input placeholder="Kraal Tag ID" />
      </Form.Item>
      <Form.Item
        label="Tag Version"
        name="version"
        rules={[{ required: true, message: messages.FIELD_REQUIRED('Tag Version') }]}>
        <Input placeholder="Tag Version" />
      </Form.Item>
      <Form.Item
        label="Tag Firmware Version"
        name="firmware_version"
        rules={[{ required: true, message: messages.FIELD_REQUIRED('Tag Firmware Version') }]}>
        <Input placeholder="Firmware Version" />
      </Form.Item>
      <Form.Item
        label="Tag Farm"
        name="farm_id"
        rules={[{ required: true, message: messages.FIELD_REQUIRED('Tag Farm') }]}>
        <Select className="w-full" options={farm_opts} />
      </Form.Item>
    </Form>
  );
}

export default memo(CreateTagForm);
